import { Check, Loader2 } from "lucide-react";

const INDIVIDUAL_FEATURES = [
  "1-day theory + 2-day practical intensive",
  "Full LymphoMetabolic protocol manual",
  "Official CPD qualification on completion",
  "Personal mentorship from Elisabete",
];

const SALON_FEATURES = [
  "Full team qualification & CPD credits",
  "Add signature high-ticket service to your menu",
  "Clinic operational and marketing guidance",
  "On-site or London venue scheduling",
];

export const Pricing = ({ onPay, onEnquire, paying, cohortLabel }) => (
  <section id="pricing" data-testid="pricing-section" className="py-24 px-6 md:px-12 max-w-6xl mx-auto">
    <div className="text-center max-w-2xl mx-auto mb-16">
      <span className="font-monolbl text-xs uppercase tracking-[0.2em] text-forest font-semibold">
        Course Investment
      </span>
      <h2 className="font-display text-3xl md:text-5xl tracking-tight text-ink mt-2 mb-4">
        Select your training track.
      </h2>
      <p className="text-moss text-base">
        Both options include full CPD accreditation, complete manual protocols, and direct
        instruction.
      </p>
      {cohortLabel && (
        <p data-testid="pricing-cohort-note" className="mt-4 text-xs font-monolbl uppercase tracking-wider text-forest">
          Reserving for: {cohortLabel}
        </p>
      )}
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
      {/* Individual Therapist */}
      <div
        data-testid="pricing-individual-card"
        className="bg-linen rounded-3xl p-8 md:p-10 border border-cream shadow-sm hover:border-forest transition-colors flex flex-col justify-between"
      >
        <div>
          <div className="flex justify-between items-start mb-6">
            <div>
              <span className="font-monolbl text-xs uppercase tracking-wider text-forest font-bold">
                Individual Track
              </span>
              <h3 className="font-display text-2xl md:text-3xl text-ink mt-1">Solo Therapist</h3>
            </div>
            <span className="px-3 py-1 rounded-full text-[11px] font-monolbl uppercase tracking-wider bg-forest/10 text-forest">
              1 Student
            </span>
          </div>
          <div className="mb-6">
            <span className="font-display text-5xl font-bold text-ink">£800</span>
            <span className="text-xs text-moss uppercase tracking-wider ml-2">Total Course Fee</span>
          </div>
          <ul className="space-y-3 text-sm text-sage mb-8 border-t border-cream pt-6">
            {INDIVIDUAL_FEATURES.map((f) => (
              <li key={f} className="flex items-center gap-2">
                <Check className="w-4 h-4 text-forest shrink-0" /> {f}
              </li>
            ))}
          </ul>
        </div>
        <div className="space-y-3">
          <button
            data-testid="pay-individual-button"
            onClick={() => onPay("course_individual")}
            disabled={paying !== null}
            className="w-full py-3.5 rounded-full bg-forest text-linen text-xs font-semibold uppercase tracking-wider text-center hover:bg-ink transition-colors disabled:opacity-60 flex items-center justify-center gap-2"
          >
            {paying === "course_individual" && <Loader2 className="w-4 h-4 animate-spin" />}
            Reserve &amp; Pay £800
          </button>
          <button
            data-testid="enquire-individual-button"
            onClick={() => onEnquire("individual")}
            className="w-full py-3 rounded-full border border-forest/30 text-forest text-xs font-semibold uppercase tracking-wider text-center hover:border-forest transition-colors"
          >
            Enquire as Individual
          </button>
        </div>
      </div>

      {/* Salon / Clinic */}
      <div
        data-testid="pricing-salon-card"
        className="bg-forest text-linen rounded-3xl p-8 md:p-10 border border-ink shadow-xl flex flex-col justify-between relative overflow-hidden"
      >
        <div>
          <div className="flex justify-between items-start mb-6">
            <div>
              <span className="font-monolbl text-xs uppercase tracking-wider text-mist font-bold">
                Commercial Track
              </span>
              <h3 className="font-display text-2xl md:text-3xl text-linen mt-1">
                Salon &amp; Clinic Team
              </h3>
            </div>
            <span className="px-3 py-1 rounded-full text-[11px] font-monolbl uppercase tracking-wider bg-white/20 text-linen">
              Team Training
            </span>
          </div>
          <div className="mb-6">
            <span className="font-display text-5xl font-bold text-linen">£3,000</span>
            <span className="text-xs text-mist uppercase tracking-wider ml-2">Salon Package</span>
          </div>
          <ul className="space-y-3 text-sm text-mist mb-8 border-t border-white/20 pt-6">
            {SALON_FEATURES.map((f) => (
              <li key={f} className="flex items-center gap-2">
                <Check className="w-4 h-4 text-mist shrink-0" /> {f}
              </li>
            ))}
          </ul>
        </div>
        <div className="space-y-3">
          <button
            data-testid="pay-salon-button"
            onClick={() => onPay("course_salon")}
            disabled={paying !== null}
            className="w-full py-3.5 rounded-full bg-linen text-forest text-xs font-semibold uppercase tracking-wider text-center hover:bg-white transition-colors disabled:opacity-60 flex items-center justify-center gap-2"
          >
            {paying === "course_salon" && <Loader2 className="w-4 h-4 animate-spin" />}
            Reserve &amp; Pay £3,000
          </button>
          <button
            data-testid="enquire-salon-button"
            onClick={() => onEnquire("salon")}
            className="w-full py-3 rounded-full border border-white/30 text-linen text-xs font-semibold uppercase tracking-wider text-center hover:border-linen transition-colors"
          >
            Enquire for Salon
          </button>
        </div>
      </div>
    </div>
  </section>
);
